import {FC, useRef} from 'react';
import clsx from 'clsx';
import SectionHeader, {SectionHeaderProps} from 'components/SectionHeader';
import useLayout from 'hooks/useLayout';

const FormHeader: FC<SectionHeaderProps> = ({className, ...rest}) => {
    const ref = useRef(null);
    const layout = useLayout(ref);

    return (
        <SectionHeader
            ref={ref}
            className={clsx(
                'pb-0',
                layout === 'sideBySide' && 'col-span-full',
                className,
            )}
            role={layout === 'sideBySide' ? 'gridcell' : 'heading'}
            {...rest}
        />
    );
};

export default FormHeader;
